import api from './api'

/**
 * Interface du résumé du tableau de bord
 */
export interface DashboardSummary {
  totalEmployees: number
  pendingLeaves: number
  activeLoans: number
  thisMonthPayroll: number
  totalPayrollAmount?: number
  totalLoanOutstanding?: number
  month?: number
  year?: number
}

/**
 * Interface pour des métriques étendues (optionnel pour futur usage)
 */
export interface DashboardMetrics {
  recentPayrolls?: {
    id: number
    periodStart: string
    periodEnd: string
    status: string
    totalNetPay: number
  }[]
  recentLoans?: {
    id: number
    employeeName: string
    principalAmount: number
    status: string
    createdAt: string
  }[]
}

/**
 * Service Dashboard
 */
class DashboardService {
  /**
   * Récupère les statistiques principales du tableau de bord
   */
  async getSummary(): Promise<DashboardSummary> {
    const response = await api.get('/dashboard/summary')
    return response.data.data
  }

  /**
   * Récupère les métriques détaillées (si tu ajoutes un /dashboard/metrics côté backend)
   */
  async getMetrics(): Promise<DashboardMetrics> {
    const response = await api.get('/dashboard/metrics')
    return response.data.data
  }

  /**
   * Formate un montant en devise locale
   */
  formatCurrency(amount: number, currency: string = 'USD'): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount)
  }

  /**
   * Formate une date en format lisible
   */
  formatDate(date: string | Date): string {
    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  /**
   * Formate la date + l'heure
   */
  formatDateTime(date: string | Date): string {
    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }
}

export const dashboardService = new DashboardService()
export default dashboardService
